/**
 * @file paddle hack awards
 * @author wanzhongyun
 */

import { Carousel } from 'antd';
import { RootObject ,ImgList,Content4} from '../../type';

import './style.less';


const HackReviewPast = (props: RootObject["reviewPast"]) => {

    const {
        titleImg,
        // jumpName,
        // jumpLink,
        imgList,
        shufflingBackImgs,
        content
    } = props;
   
    return (
        <div className='paddle-hack-ReviewPast-wrapper'>
            <div className='paddle-hack-ReviewPast-content'>
            <div className="ReviewPast-content-back" style={{ backgroundImage: `url(${shufflingBackImgs})` }}></div>
                <div className='paddle-hack-ReviewPast-content-header'>
                    <img className='paddle-hack-ReviewPast-title' src={titleImg} alt='' />
                    {/* <div className='paddle-hack-ReviewPast-desc'>
                        <a href={jumpLink} target='_blank' rel="noreferrer">&nbsp;&nbsp;{jumpName ?? ""}&nbsp;<RightOutlined /></a>
                    </div> */}
                </div>

                <div className="ReviewPast-content-wrapper">
                    <ul className="ReviewPast-content-desc">
                       {content?.map((value:Content4,index:number)=>{
                           return (
                            <li key={index}>
                            <a href={value.lLink}  target='_blank' rel="noreferrer" className="ReviewPast-li-desc">
                                {value.describe ?? ""}
                            </a>
                            <div className="ReviewPast-li-time">
                               {value.time ?? ""}
                            </div>
                        </li>
                           )
                       })}
                    </ul>
                    <div className="ReviewPast-content-shuffling">
                        <Carousel autoplay={false}>
                            {imgList?.map((value:ImgList,index:number)=>{
                                return (
                                    <img className="shuffling-img" src={value.shufflingImgs} key={index} alt={value.shufflingImgs}>
                                    </img>
                                )
                            })}
                        </Carousel>
                    </div>
                    
                </div>
            </div>
           
        </div>
    );
};

export default HackReviewPast;